var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.12132 0L11.6634 9.54213L21.2132 0L23.3345 2.12132L13.7848 11.6634L23.3345 21.2132L21.2132 23.3345L0 2.12132L2.12132 0ZM7.89767 13.3396L0 21.2132L2.12132 23.3345L10.019 15.4609L7.89767 13.3396Z","fill":"white"}));
}

CloseIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
